import { useEnvironment } from '@/composables/useEnvironment';
import { apiBase, inSlot } from '@/utils/slot';

/**
 * Returns the passed path formatted for API calls.
 * @param {*} path
 * @param {$} override
 * @returns
 */
function getPath(path, override) {
  if (override) return inSlot(`${override}${path}`);

  const { isLocal } = useEnvironment();

  if (isLocal()) {
    path = window.location.origin.concat(['/'], path);
  } else {
    path = apiBase().concat(['/'], path);
  }
  return path;
}

export default getPath;
